import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import adobeLogo from '../../../images/pricingPage/clientLogos/adobe.png';
import amazonLogo from '../../../images/pricingPage/clientLogos/amazon.png';
import upworkLogo from '../../../images/pricingPage/clientLogos/upwork.png';
import yelpLogo from '../../../images/pricingPage/clientLogos/yelp.png';
import creativeMorningsLogo from '../../../images/pricingPage/clientLogos/creativemornings.png';
import zoomLogo from '../../../images/pricingPage/clientLogos/zoom.png';
import googleLogo from '../../../images/pricingPage/clientLogos/google.png';
import miroLogo from '../../../images/pricingPage/clientLogos/miro.png';

const logos = [
  { src: adobeLogo, name: 'Adobe' },
  { src: amazonLogo, name: 'Amazon' },
  { src: upworkLogo, name: 'Upwork' },
  { src: yelpLogo, name: 'Yelp' },
  { src: creativeMorningsLogo, name: 'CreativeMornings' },
  { src: zoomLogo, name: 'Zoom' },
  { src: googleLogo, name: 'Google' },
  { src: miroLogo, name: 'Miro' },
];

const LogoCarousel: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const [animationDuration, setAnimationDuration] = useState<number>(0);

  useEffect(() => {
    if (trackRef.current) {
      const trackWidth = trackRef.current.offsetWidth / 2; // Width of one set of logos
      const speed = 100; // Adjust this value to control speed (pixels per second)
      const duration = trackWidth / speed; // Calculate duration based on width and speed
      setAnimationDuration(duration);
    }
  }, []);

  return (
    <CarouselWrapper>
      <CarouselTrack
        animationDuration={animationDuration > 0 ? animationDuration : undefined}
        ref={trackRef}
      >
        {[...logos, ...logos].map((logo, index) => (
          <Logo alt={logo.name} key={index} src={logo.src} />
        ))}
      </CarouselTrack>
    </CarouselWrapper>
  );
};

const CarouselWrapper = styled('div')`
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  padding: 40px 0;
`;

interface CarouselTrackProps {
  animationDuration?: number;
}

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const CarouselTrack = styled('div')<CarouselTrackProps>`
  display: flex;
  align-items: center;
  width: max-content;
  opacity: 50%;
  ${({ animationDuration }) =>
    animationDuration
      ? css`
          animation: ${scroll} ${animationDuration}s linear infinite;
        `
      : 'animation: none;'}
`;

const Logo = styled('img')`
  width: 150px;
  height: auto;
  margin: 0 20px;
  flex-shrink: 0;
  filter: grayscale(100%) contrast(50%) saturate(500%) brightness(80%);
`;

export default LogoCarousel;
